import React from "react";
import "./Game.css";
import ReadyPlayers from "./ReadyPlayers/ReadyPlayers";
import GameContent from "./GameContent/GameContent";

const Game = ({
  users,
  name,
  readyPlayer,
  chatboxBool,
  startGame,
  gameData,
  room,
  updateBoard,
  boardSelectionNum,
  updateRoundParams,
  roundParams,
  roundStarted,
  updateRoundStarted,
  updateVoteData,
  voteCountData,
  currentVotingData,
  resetRoundData,
  chameleonGuess,
  setChameleonGuess,
  showResults,
  setShowResults,
  sendGuessedWord,
  guessedWord,
  currentScores,
  roundScore,
  calcScores,
  updatePromptData,
  currentPromptData,
}) => {
  return (
    <div className={chatboxBool ? "gameContainerLarge" : "gameContainer"}>
      {users ? (
        <div className="gameboxContent">
          {gameData.gameStarted !== true ? (
            <ReadyPlayers
              users={users}
              name={name}
              readyPlayer={readyPlayer}
              startGame={startGame}
              room={room}
              gameData={gameData}
            ></ReadyPlayers>
          ) : (
            <GameContent
              users={users}
              name={name}
              updateBoard={updateBoard}
              boardSelectionNum={boardSelectionNum}
              updateRoundParams={updateRoundParams}
              roundParams={roundParams}
              roundStarted={roundStarted}
              updateRoundStarted={updateRoundStarted}
              updateVoteData={updateVoteData}
              voteCountData={voteCountData}
              currentVotingData={currentVotingData}
              resetRoundData={resetRoundData}
              chameleonGuess={chameleonGuess}
              setChameleonGuess={setChameleonGuess}
              showResults={showResults}
              setShowResults={setShowResults}
              sendGuessedWord={sendGuessedWord}
              guessedWord={guessedWord}
              currentScores={currentScores}
              roundScore={roundScore}
              calcScores={calcScores}
              updatePromptData={updatePromptData}
              currentPromptData={currentPromptData}
            ></GameContent>
          )}
        </div>
      ) : (
        <div className="activeContainer">
          <p className="noPlayers"> Server error: No users found</p>
        </div>
      )}
    </div>
  );
};

export default Game;
